export default function calcPercentageOnPlannerBar(value,maxValue = 0,numberSliceOfBar = 1) {

    if(!maxValue) return 0
    if(!value) return 0

    return (value  / (maxValue/100)) / numberSliceOfBar
}